import { decodeUtf8Base64 } from './maternityClaimFormHtml'

/**
 * Opens maternity claim HTML in a new window and triggers the browser print dialog
 * (same pattern as printPrescription / printPatientInstructions).
 */
export function printMaternityClaimForm(base64Content: string): void {
  let html: string
  try {
    html = decodeUtf8Base64(base64Content)
  } catch (e) {
    console.error('printMaternityClaimForm: decode failed', e)
    window.alert('Could not open the claim form for printing. Please try again.')
    return
  }

  const printWindow = window.open('', '_blank', 'width=900,height=800')
  if (!printWindow) {
    window.alert('Please allow pop-ups to print the maternity claim form.')
    return
  }

  printWindow.document.open()
  printWindow.document.write(html)
  printWindow.document.close()

  const triggerPrint = (): void => {
    try {
      printWindow.focus()
      printWindow.print()
    } catch (err) {
      console.error('printMaternityClaimForm: print failed', err)
    }
  }

  const schedulePrint = (): void => {
    setTimeout(triggerPrint, 250)
  }

  if (printWindow.document.readyState === 'complete') {
    schedulePrint()
  } else {
    printWindow.onload = schedulePrint
  }
}
